import ace from 'ace-builds'

import modeJsonUrl from 'ace-builds/src-noconflict/mode-json?url'
ace.config.setModuleUrl('ace/mode/json', modeJsonUrl)
import workerJsonUrl from 'ace-builds/src-noconflict/worker-json?url'
ace.config.setModuleUrl('ace/mode/json_worker', workerJsonUrl)
import snippetsJsonUrl from 'ace-builds/src-noconflict/snippets/json?url'
ace.config.setModuleUrl('ace/snippets/json', snippetsJsonUrl)

import modeJavascriptUrl from 'ace-builds/src-noconflict/mode-javascript?url'
ace.config.setModuleUrl('ace/mode/javascript', modeJavascriptUrl)
import workerJavascriptUrl from 'ace-builds/src-noconflict/worker-javascript?url'
ace.config.setModuleUrl('ace/mode/javascript_worker', workerJavascriptUrl)
import snippetsJsUrl from 'ace-builds/src-noconflict/snippets/javascript?url'
ace.config.setModuleUrl('ace/snippets/javascript', snippetsJsUrl)

import modeHtmlUrl from 'ace-builds/src-noconflict/mode-html?url'
ace.config.setModuleUrl('ace/mode/html', modeHtmlUrl)
import workerHtmlUrl from 'ace-builds/src-noconflict/worker-html?url'
ace.config.setModuleUrl('ace/mode/html_worker', workerHtmlUrl)
import snippetsHtmlUrl from 'ace-builds/src-noconflict/snippets/html?url'
ace.config.setModuleUrl('ace/snippets/html', snippetsHtmlUrl)

import modeCssUrl from 'ace-builds/src-noconflict/mode-css?url'
ace.config.setModuleUrl('ace/mode/css', modeCssUrl)
import workerCssUrl from 'ace-builds/src-noconflict/worker-css?url'
ace.config.setModuleUrl('ace/mode/css_worker', workerCssUrl)
import snippetsCssUrl from 'ace-builds/src-noconflict/snippets/css?url'
ace.config.setModuleUrl('ace/snippets/css', snippetsCssUrl)

import modeScssUrl from 'ace-builds/src-noconflict/mode-scss'
ace.config.setModuleUrl('ace/mode/scss', modeScssUrl)
import snippetsScssUrl from 'ace-builds/src-noconflict/snippets/scss?url'
ace.config.setModuleUrl('ace/snippets/scss', snippetsScssUrl)

import themeChromeUrl from 'ace-builds/src-noconflict/theme-chrome?url'
ace.config.setModuleUrl('ace/theme/chrome', themeChromeUrl)
import themeMonokaiUrl from 'ace-builds/src-noconflict/theme-monokai?url'
ace.config.setModuleUrl('ace/theme/monokai', themeMonokaiUrl)

import workerBaseUrl from 'ace-builds/src-noconflict/worker-base?url'
ace.config.setModuleUrl('ace/mode/base', workerBaseUrl)

import 'ace-builds/src-noconflict/ext-language_tools'
ace.require('ace/ext/language_tools')
